import React from "react";
import styled from "styled-components";
import Box from "../layout/Box";
var IconBase = styled(Box).attrs(function(props) {
    var ref;
    var color = (props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : ref.colors[props === null || props === void 0 ? void 0 : props.color]) || (props === null || props === void 0 ? void 0 : props.color) || null;
    return {
        as: "svg",
        display: "block",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: color
    };
})({});
export default IconBase;
